import { render, staticRenderFns } from "./global-alert.vue?vue&type=template&id=036ca128"
import script from "./global-alert.vue?vue&type=script&lang=js"
export * from "./global-alert.vue?vue&type=script&lang=js"
import style0 from "./global-alert.vue?vue&type=style&index=0&id=036ca128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports